import React from 'react';
import { Stack } from '@mui/material';
import { StepTitle } from '../StepTitle';
import { StepIndicatorStates } from 'components/StepIndicator';
import { useIntl } from 'react-intl';
import { Contract } from 'modules/contract/types';
import { ChooseLineItemStepActive } from './ChooseLineItemStepActive';
import { ChooseLineItemStepCompleted } from './ChooseLineItemStepCompleted';

interface ChooseLineItemStepProps {
  state: StepIndicatorStates
  completeStep(lineItemId: number): void
  contract?: Contract
  lineItemIndex?: number
  onEditStep(): void
}

export const ChooseLineItemStep: React.FC<ChooseLineItemStepProps> = ({ state, contract, lineItemIndex: lineItemIndex, onEditStep, completeStep }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack>
      <StepTitle
        number={2}
        state={state}
        onEditClick={onEditStep}
        activeTitle={formatMessage({ id: 'FindServiceCall.ChooseArticleStep.ActiveTitle', defaultMessage: 'Choose article' })}
        completedTitle={formatMessage({ id: 'FindServiceCall.ChooseArticleStep.CompletedTitle', defaultMessage: 'Selected article' })}
        incompleteTitle={formatMessage({ id: 'FindServiceCall.ChooseArticleStep.IncompleteTitle', defaultMessage: 'Contract articles' })}
      />
      {state === 'active' &&
        <ChooseLineItemStepActive contract={contract} completeStep={completeStep} />
      }
      {lineItemIndex && contract && state === 'complete' &&
        <ChooseLineItemStepCompleted product={contract.lineItems[lineItemIndex].product} />
      }
    </Stack>
  );
};